export function requestNotificationPermission() {
  if ("Notification" in window) {
    return Notification.requestPermission().then(
      function gettingNotificationPermission(permission) {
        if (permission === "granted") {
          return true;
        } else {
          return false;
        }
      }
    );
  } else {
    return Promise.reject("Notification is not supported in this browser");
  }
}
